import React, { useEffect } from 'react';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 多选区域筛选器
  MULTIPLE_AREA_SELECT as FILTER_MULTIPLE_AREA_SELECT,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getIsMonthlyRank } from '@/pages/intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/StoreRank/utils';
import { CONSOLE_PLATFORM_NINTENDO, CONSOLE_TOP_FREE_TO_PLAY } from '@/pages/intelligence/_config/storeRank/config';

import type { IRegion } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsFilter } from '../../../types';

const getDateTypes = (cfg: { isMonthlyRank: boolean; top: string; }): string[] => {
  const { isMonthlyRank, top } = cfg ?? {};
  if (top === CONSOLE_TOP_FREE_TO_PLAY) return ['date', 'month'];
  return isMonthlyRank ? ['month'] : ['date'];
};

export default function useUpdateFiltersCfg(props: {
  filter: IStoreRankDetailsFilter;
  regionsOptionsMap: { [key: string]: IRegion[]; };
  inputList: any[];
  setInputList: React.Dispatch<React.SetStateAction<any[]>>;
  nintendoUsOnly: boolean;
  sinceReleaseTime?: string;
  earliestDataTime?: string;
}) {
  const { filter, regionsOptionsMap, inputList, setInputList, nintendoUsOnly,
    sinceReleaseTime,
    earliestDataTime,
  } = props ?? {};

  // 更新 日期筛选器配置
  const upateRangeTimeCfg = (
    inputList: any[],
    cfg: {
      isMonthlyRank: boolean;
      top: string;
    },
    sinceReleaseTime?: string,
    earliestDataTime?: string,
  ) => {
    const filterRangeTime = inputList?.find((item) => item?.key === FILTER_RANGE_TIME);
    if (!filterRangeTime) return;
    const typeListTmp = getDateTypes(cfg);
    filterRangeTime.showSelectType = typeListTmp?.length > 1;
    filterRangeTime.typeList = typeListTmp;
    filterRangeTime.sinceReleaseTime = sinceReleaseTime || '';
    filterRangeTime.earliestDataTime = earliestDataTime || '';
  };

  // 更新单选、多选国家筛选器
  const updateComposedCountrySelect = (
    inputList: any[],
    cfg: { isVisible: boolean; isDisabled: boolean; isMonthlyRank: boolean; regionsOptions: IRegion[]; isShowTypeSelect: boolean; },
  ) => {
    const { isVisible, isDisabled, isMonthlyRank, regionsOptions, isShowTypeSelect } = cfg ?? {};
    const filterComposedCountrySelectTmp = inputList?.find((item) => item?.key === FILTER_COMPOSED_COUNTRY_SELECT);
    if (!filterComposedCountrySelectTmp) return;
    filterComposedCountrySelectTmp.visible = !isVisible || isMonthlyRank ? 2 : 1;
    filterComposedCountrySelectTmp.disabled = isDisabled;
    filterComposedCountrySelectTmp.options = regionsOptions ?? [];
    // Nintendo不展示单一国家/多选国家
    filterComposedCountrySelectTmp.isShowTypeSelect = isShowTypeSelect;
  };

  // 更新区域筛选器
  const updateRegionSelect = (inputList: any[], cfg: { isMonthlyRank: boolean; }) => {
    const { isMonthlyRank } = cfg ?? {};
    const filterRegionTmp = inputList?.find((item) => item?.key === FILTER_MULTIPLE_AREA_SELECT);
    if (!filterRegionTmp) return;
    filterRegionTmp.visible = isMonthlyRank ? 1 : 2;
  };

  useEffect(() => {
    const inputListTmp = [...inputList];
    const isMonthlyRank = getIsMonthlyRank({
      platform: filter?.platform,
      top: filter?.top,
      granularity: filter?.granularity,
    });
    const regionsOptions = nintendoUsOnly ? regionsOptionsMap?.nintendoUsOnly : regionsOptionsMap?.[filter?.platform];
    const isNintendo = filter?.platform === CONSOLE_PLATFORM_NINTENDO;
    // 更新 日期筛选器配置
    upateRangeTimeCfg(inputListTmp, { isMonthlyRank, top: filter?.top },sinceReleaseTime,
      earliestDataTime,);
    // 更新单选、多选国家筛选器
    updateComposedCountrySelect(inputListTmp, {
      isVisible: true,// !nintendoUsOnly,
      isDisabled: false,// nintendoUsOnly,
      isMonthlyRank,
      regionsOptions,
      isShowTypeSelect: !isNintendo,
    });
    // 更新区域筛选器
    updateRegionSelect(inputListTmp, { isMonthlyRank });
    setInputList(inputListTmp);
  }, [filter?.platform, filter?.top, filter?.granularity, regionsOptionsMap,
    sinceReleaseTime,
    earliestDataTime,
  ]);
}
